import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=55545174&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"
import style0 from "./Form.vue?vue&type=style&index=0&id=55545174&prod&scoped=true&lang=css"
import style1 from "./Form.vue?vue&type=style&index=1&id=55545174&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55545174",
  null
  
)

export default component.exports